import { IdType } from 'ts/IdType';

export enum CardStatusType {
  ACTIVE = 'ACTIVE',
  REDEEMED = 'REDEEMED',
  CANCELED = 'CANCELED',
  EXPIRED = 'EXPIRED',
}

export interface RedemptionReport {
  order_id: IdType;
  gift_card: string;
  date: string;
  recipient_name: string;
  product: string;
  currency: string;
  denomination: number;
  card_status: CardStatusType;
}

export type CancelCardSummary = {
  refund_amount: number;
  vat_amount: number;
  cancel_fee_amount: number;
  currency: string;
};
